// this file is overwritten by the build process
var API_VERSION = 'v1';
var TTT_VERSION = '1.16.1';
export { API_VERSION, TTT_VERSION };
